type DecicionWhenType = boolean;

type DecisionthenType<T> = () => T;

interface DecisionType<T> {
    when: DecicionWhenType[];
    then: DecisionthenType<T>;
}

export const decide = <T>(decisions: DecisionType<T>[]): T | null => {
    for (const decision of decisions) {
        if (decision.when.every((condition) => condition)) {
            return decision.then();
        }
    }

    return null;
};
